import React, { useState, useEffect } from 'react'
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { toast } from 'react-toastify';
import InventoryItemsAPI from '../../services/InventoryItem';
import Loading from '../util/loading/Loading';
import Modal from '../util/modal/Modal';
import CaffenioDriveAPI from '../../services/caffenioDrive';
import Select from 'react-select';
import SustitutosInsumosAPI from '../../services/SustitutosInsumos';
import ErrorMessages from '../../util/validation-error-messages';

export const NewSustitutosInsumos = ({ history }) => {

    const NUM_INSUMVIEJO = 1
    const NUM_INSUMNUEVO = 2

    const [state, setState] = useState({
        filtroInsumoViejo: '',
        filtroInsumoNuevo: '',
        insumoViejo: null,
        insumoNuevo: null,
        drivesAsignados: [],
        isLoading: false,
        listaArtInvAux: [],
        listaDrives: [],
        modalArtInv: false,
        FiltroActivo: 0,
    })

    useEffect(() => {
        CaffenioDriveAPI.getCaffenios()
            .then(res => {
                let listaDrivesAux = res.data.filter(x => x.Active === true)
                setState({ ...state, listaDrives: listaDrivesAux })
            })
            .catch(err => {
                setState({ ...state, isLoading: false })
                if (err.response) {
                    toast.error(err.response.data.Message)
                } else {
                    toast.error(ErrorMessages.SinConexion)
                }
            })
    }, [])


    const buscarArticuloInventario = (tipoFiltroInsumo) => {
        let body = {
            Search: tipoFiltroInsumo === 1 ? state.filtroInsumoViejo.trim() : state.filtroInsumoNuevo.trim(),
            Total: 10,
            ItemInventoryIds: [],
            Toppings: false
        };
        setState({ ...state, isLoading: true });
        InventoryItemsAPI.search(body)
            .then(res => {
                setState({ ...state, isLoading: false, modalArtInv: true, listaArtInvAux: res.data.Results, FiltroActivo: tipoFiltroInsumo });
            })
            .catch(err => {
                console.log(err)
                setState({ ...state, isLoading: false });
                toast.error(err.response.data)
            });
    }

    const handleFiltroInsumo = (tipoFiltroInsumo, texto) => {
        if (tipoFiltroInsumo === NUM_INSUMVIEJO) {
            setState({ ...state, filtroInsumoViejo: texto })
        } else if (tipoFiltroInsumo === NUM_INSUMNUEVO) {
            setState({ ...state, filtroInsumoNuevo: texto })
        }
    }

    const EliminarInsumoEstablecido = (tipoFiltroInsumo) => {
        if (tipoFiltroInsumo === NUM_INSUMVIEJO) {
            setState({ ...state, filtroInsumoViejo: '', insumoViejo: null, listaArtInvAux: [], FiltroActivo: 0 })
        } else if (tipoFiltroInsumo === NUM_INSUMNUEVO) {
            setState({ ...state, filtroInsumoNuevo: '', insumoNuevo: null, listaArtInvAux: [], FiltroActivo: 0 })
        }
    }

    const GuardarInsumo = () => {
        setState({...state, isLoading: true})
        if (state.insumoViejo === null) {
            toast.error('Se debe asignar un insumo viejo')
            return
        }
        if (state.insumoNuevo === null) {
            toast.error('Se debe asignar un insumo nuevo')
            return
        }
        if (state.drivesAsignados.length === 0) {
            toast.error('Se debe establecer por lo menos un drive')
            return
        }

        let listaSustitutosInsumos = []
        state.drivesAsignados.forEach(drive => {
            let sustitutoInsumoAux = {
                IdCaffenio: drive.idCaffenio,
                IdSustitutoViejo: state.insumoViejo.InventoryItemId,
                IdSustitutoNuevo: state.insumoNuevo.InventoryItemId
            }
            listaSustitutosInsumos.push(sustitutoInsumoAux)
        });

        SustitutosInsumosAPI.CreateSustitutos(listaSustitutosInsumos)
            .then(res => {
                setState({...state, isLoading: false})
                toast.success('El sustituto en los drives fue guardado correctamente')
                history.goBack()
            })
            .catch(err => {
                setState({ ...state, isLoading: false })
                if (err.response) {
                    toast.error(err.response.data.Message)
                } else {
                    toast.error(ErrorMessages.SinConexion)
                }
            })
    }

    return (
        <div className='card'>
            <div className='card-header'>
                <div className="card-header-title is-size-4 center-text">
                    <span style={{ position: "absolute", left: 25 }} className="is-primary tooltip" data-tooltip="Ir Atrás">
                        <i className="fa fa-arrow-left" style={{ cursor: "pointer", color: "#91BA43" }} onClick={() => { history.goBack() }}></i>
                    </span>
                    <div>{"Nuevo sustituto de insumo"}</div>
                </div>
            </div>
            <div className='card-content'>
                <div className="row">
                    <div className='columns is-multiline'>

                        <div className='column is-6'>
                            <label className='label'>Insumo Viejo</label>
                            <div className="control">
                                <input
                                    value={state.filtroInsumoViejo}
                                    onChange={e => handleFiltroInsumo(NUM_INSUMVIEJO, e.currentTarget.value)}
                                    className={`input`}
                                    disabled={state.insumoViejo === null ? false : true}
                                    placeholder={"Ingrese código o nombre del artículo"}
                                    onKeyDown={evt => {
                                        if (evt.key === "Enter") {
                                            buscarArticuloInventario(NUM_INSUMVIEJO)
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div className='column is-6'>
                            <label className='label'>Insumo Nuevo</label>
                            <div className="control">
                                <input
                                    value={state.filtroInsumoNuevo}
                                    onChange={e => handleFiltroInsumo(NUM_INSUMNUEVO, e.currentTarget.value)}
                                    className={`input`}
                                    disabled={state.insumoNuevo === null ? false : true}
                                    placeholder={"Ingrese código o nombre del artículo"}
                                    onKeyDown={evt => {
                                        if (evt.key === "Enter") {
                                            buscarArticuloInventario(NUM_INSUMNUEVO)
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <div className='column is-6'>
                            {state.insumoViejo !== null && <button
                                className="button is-danger"
                                onClick={() => EliminarInsumoEstablecido(NUM_INSUMVIEJO)}
                            >
                                <span className="icon is-small">
                                    <i className="fa fa-trash"></i>
                                </span>
                            </button>}
                        </div>

                        <div className='column is-6'>
                            {state.insumoNuevo !== null && <button
                                className="button is-danger"
                                onClick={() => EliminarInsumoEstablecido(NUM_INSUMNUEVO)}
                            >
                                <span className="icon is-small">
                                    <i className="fa fa-trash"></i>
                                </span>
                            </button>}
                        </div>

                        <br /><br /><br /><br />

                        <div className='column is-12'>
                            <label className='label'>Seleccionar drives</label>
                            <div className="control" style={{ width: "100%" }}>
                                <Select
                                    //closeMenuOnSelect={false}
                                    menuPlacement="auto"
                                    value={state.drivesAsignados}
                                    isMulti
                                    placeholder={"Seleccionar..."}
                                    noOptionsMessage={() => "No hay opciones"}
                                    options={state.listaDrives}
                                    onChange={val => {
                                        setState({ ...state, drivesAsignados: val })
                                    }}
                                    getOptionLabel={(drive) => drive.Name}
                                    getOptionValue={(drive) => drive.idCaffenio}
                                />
                            </div>
                        </div>

                    </div>
                    <br />
                    <div className="has-text-right buttons-modal">
                        <div className="column">
                            <button
                                className="button is-success"
                                onClick={GuardarInsumo}
                                disabled={state.insumoNuevo === null || state.insumoViejo === null || state.drivesAsignados.length === 0}
                            >
                                <span>Guardar</span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>

            <Loading isFullscreen={true} isLoading={state.isLoading} width='100px' height='100px' />

            <Modal
                showModal={state.modalArtInv}
                modalTitle={`Seleccionar insumo ${state.FiltroActivo === NUM_INSUMNUEVO ? 'nuevo' : 'viejo'}`}
                width="55%"
                cancel={() => setState({ ...state, modalArtInv: false })}
            >
                <div className="card">
                    <div className="card-content">
                        <table className='table is-fullwidth'>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Código</th>
                                    <th>Artículo inventario</th>
                                    <th>Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    state.listaArtInvAux.map(articuloInventario =>
                                        <tr key={articuloInventario.InventoryItemId}>
                                            <td>{articuloInventario.InventoryItemId}</td>
                                            <td>{articuloInventario.InventoryCode}</td>
                                            <td>{articuloInventario.Name}</td>
                                            <td>
                                                <a className="button tableAction is-success" onClick={(e) => {
                                                    e.stopPropagation();
                                                    let filtroInsumoNombre = `${articuloInventario.InventoryCode} - ${articuloInventario.Name}`
                                                    if (state.FiltroActivo === NUM_INSUMVIEJO) {
                                                        if (state.insumoNuevo !== null) {
                                                            if (articuloInventario.InventoryItemId === state.insumoNuevo.InventoryItemId) {
                                                                toast.error('El artículo ya se encuentra establecido en insumo nuevo')
                                                            } else {
                                                                setState({ ...state, insumoViejo: articuloInventario, modalArtInv: false, filtroInsumoViejo: filtroInsumoNombre })
                                                            }
                                                        } else {
                                                            setState({ ...state, insumoViejo: articuloInventario, modalArtInv: false, filtroInsumoViejo: filtroInsumoNombre })
                                                        }
                                                    } else if (state.FiltroActivo === NUM_INSUMNUEVO) {
                                                        if (state.insumoViejo !== null) {
                                                            if (articuloInventario.InventoryItemId === state.insumoViejo.InventoryItemId) {
                                                                toast.error('El artículo ya se encuentra establecido en insumo viejo')
                                                            } else {
                                                                setState({ ...state, insumoNuevo: articuloInventario, modalArtInv: false, filtroInsumoNuevo: filtroInsumoNombre })
                                                            }
                                                        } else {
                                                            setState({ ...state, insumoNuevo: articuloInventario, modalArtInv: false, filtroInsumoNuevo: filtroInsumoNombre })
                                                        }
                                                    }
                                                }
                                                }>
                                                    <span className="icon">
                                                        <i className="fa fa-plus" />
                                                    </span>
                                                </a>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>

        </div>
    )
}